'use strict';

// some array functions
Array.prototype.insert = function (index, item) {
	this.splice(index, 0, item);
};
Array.prototype.insertAll = function (index, array) {
	if (index>=this.length) {
		this.pushAll(array);
	} else {
		this.splice.apply(this, [index, 0].concat(array));
	}
};
Array.prototype.pushAll = function (array) {
	this.push.apply(this, array);
};
Array.prototype.remove = function (item) {
	return this.indexOf(item) > -1
		? this.splice(this.indexOf(item), 1)
		: undefined;
};
Array.prototype.removeAll = function () {
	return this.splice(0, this.length);
};
Array.prototype.removeAt = function (index) {
	return index > -1 ? this.splice(index, 1) : undefined;
};
Array.prototype.removeRange = function (index, length) {
	return this.splice(index, length);
};
Array.prototype.last = function () {
	return this[this.length - 1];
};
Array.prototype.swap = function (x, y) {
	var b = this[x];
	this[x] = this[y];
	this[y] = b;
	return this;
};
Array.prototype.isEmpty = function () {
	return this.length === 0;
};
Array.prototype.contains = function (item) {
	return this.indexOf(item) > -1;
};

Array.prototype.move = Array.prototype.move || function(moveFrom, moveTo) {
	if ((moveFrom < 0) || (moveFrom > this.length-1)) return this;
	if (moveFrom === moveTo) return this;
	if (moveTo < 0) moveTo=0;
	if (moveTo > this.length-1) moveTo = this.length-1;

	var targetValue = this[moveTo];
	var initialValue = this[moveFrom];

	this[moveTo]=initialValue;

	if (moveTo > moveFrom) {
		this.splice(moveTo, 0, targetValue);
		this.removeAt(moveFrom);
	} else {
		this.splice(moveTo+1, 0, targetValue);
		this.removeAt(moveFrom+1);
	}

	return this;
};

Array.prototype.moveToBeginning = function(moveFrom) {
	if (this.length === 0 || moveFrom <= 0 || moveFrom > (this.length - 1)) return;

	this.move(moveFrom, 0);

	return this;
};

Array.prototype.moveToEnd = function(moveFrom) {
	if (this.length === 0 || moveFrom < 0 || moveFrom >= (this.length - 1)) return;

	this.move(moveFrom, this.length-1);

	return this;
};

// remove item if it violates a rule
// predicate returning true = remove item
// predicate returning false = item is okay
Array.prototype.preventAtIndex = function(index, predicateFn) {
	if (predicateFn(this[index])) {
		this.removeAt(index);
	}

	return this;
};

Array.prototype.preventFirst = function(predicateFn) {
	return this.preventAtIndex(0, predicateFn);
};

Array.prototype.preventLast = function(predicateFn) {
	return this.preventAtIndex(this.length-1, predicateFn);
};

Array.prototype.preventConsecutive = function(predicateFn) {
	var i = 0;

	while (i < this.length - 1) {
		if (predicateFn(this[i]) && predicateFn(this[i+1])) {
			this.removeAt(i);
		} else {
			i++;
		}
	}
	return this;
};


if (!Array.prototype.find) {
	Array.prototype.find = function (predicate) {
		if (this === null) {
			throw new TypeError('Array.prototype.find called on null or undefined');
		}
		if (typeof predicate !== 'function') {
			throw new TypeError('predicate must be a function');
		}
		var list = Object(this);
		var length = list.length >>> 0;
		var thisArg = arguments[1];
		var value;

		for (var i = 0; i < length; i++) {
			value = list[i];
			if (predicate.call(thisArg, value, i, list)) {
				return value;
			}
		}
		return undefined;
	};
}

// returns numeric value this is a little more robust than simply doing parseFloat,
// which will crop it at the first non-numeric character
String.prototype.getNumericValue = function() {
	if (this === null || this === undefined || this === 'NaN') return this;
	return parseFloat(this.match(/[0-9\.]/g).join(''));
};

// String.prototype.startsWith = String.prototype.startsWith || function (chars) {
// 	return this.left(chars.length) === chars;
// };

String.prototype.endsWith = function (chars) {
	return this.right(chars.length) === chars;
};

String.prototype.contains = function(chars) {
	return this.indexOf(chars) > -1;
};

String.prototype.left = function (chars) {
	return (this.length < chars) ? this : this.substring(0, chars);
};

String.prototype.right = function (chars) {
	return (this.length < chars) ? this : this.substring(this.length - chars);
};

// return string with brackets converted to entities
String.prototype.bracketsToEntities = function() {
	return this.replace(/</g, '&lt;').replace(/>/g, '&gt;');
};

String.prototype.entitiesToBrackets = function() {
	return this.replace('&lt;', '<').replace('&gt;', '>');
};

String.prototype.capitalize = function() {
	if (!this.length) return '';
	return this[0].toUpperCase() + this.substr(1).toLowerCase();
};
String.prototype.sentenceCase = String.prototype.capitalize;

String.prototype.capitalizeEveryWord = function(extraSeparators) {
	var tempString = this.toLowerCase().split(' ').map(function(eachWord) {
		return eachWord.capitalize();
	}).join(' ');

	if (extraSeparators && extraSeparators.length) {
		for (var i=0; i<extraSeparators.length; i++) {
			var separator = extraSeparators[i];

			tempString = tempString.split(separator).map(function(eachWord) {
				return eachWord.capitalizeFirstLetter();
			}).join(separator);
		}
		return tempString;
	}

	return tempString;
};

// makes first letter uppercase without touching the rest of it
String.prototype.capitalizeFirstLetter = function() {
	if (!this.length) return;
	return this[0].toUpperCase() + this.substr(1);
};

String.prototype.underscoreToSpace = function() {
	return this.replace(/_/g, ' ');
};

String.prototype.doFormat = function () {
	var str = this.toString();
	if (arguments.length) {
		var t = typeof arguments[0];
		var key;
		var args = ('string' === t || 'number' === t) ?
			Array.prototype.slice.call(arguments) : arguments[0];

		for (key in args) {
			str = str.replace(new RegExp('\\{' + key + '\\}', 'gi'), args[key]);
		}
	}

	return str;
};

if (!String.prototype.repeat) {
	String.prototype.repeat = function(count) {
		if (this === null) {
			throw new TypeError('can\'t convert ' + this + ' to object');
		}
		var str = '' + this;
		count = +count;
		if (count !== count) {
			count = 0;
		}
		if (count < 0) {
			throw new RangeError('repeat count must be non-negative');
		}
		if (count === Infinity) {
			throw new RangeError('repeat count must be less than infinity');
		}
		count = Math.floor(count);
		if (str.length === 0 || count === 0) {
			return '';
		}
		// Ensuring count is a 31-bit integer allows us to heavily optimize the
		// main part. But anyway, most current (August 2014) browsers can't handle
		// strings 1 << 28 chars or longer, so:
		if (str.length * count >= 1 << 28) {
			throw new RangeError('repeat count must not overflow maximum string size');
		}
		var rpt = '';
		for (var i = 0; i < count; i++) {
			rpt += str;
		}
		return rpt;
	};
}

if (!String.prototype.padEnd) {
	String.prototype.padEnd = function padEnd(targetLength, padString) {
		targetLength = targetLength >> 0; //floor if number or convert non-number to 0;
		padString = String((typeof padString !== 'undefined' ? padString : ' '));
		if (this.length > targetLength) {
			return String(this);
		} else {
			targetLength = targetLength - this.length;
			if (targetLength > padString.length) {
				padString += padString.repeat(targetLength / padString.length); //append to original to ensure we are longer than needed
			}
			return String(this) + padString.slice(0, targetLength);
		}
	};
}

String.prototype.replaceAt = function(startIndex, endIndex, replaceWith) {
	var before = this.slice(0, startIndex);
	var after = this.slice(endIndex + 1);
	return before + replaceWith + after;
};

String.prototype.escapeRegExp = String.prototype.escapeRegExp || function() {
	return this.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, '\\$1');
};

if (!String.prototype.replaceAll) {

	String.prototype.replaceAll = function(find, replace) {
		return this.replace(new RegExp(find.escapeRegExp(), 'g'), replace);
	};
}

String.prototype.toAlphaNumeric = String.prototype.alphaNumeric || function(replaceWith) {
	replaceWith = replaceWith || '';
	return this.replace(/[^A-Za-z0-9]/g, replaceWith);
}

String.prototype.toKabobCase = String.prototype.toKabobCase || function() {
	var retVal = this.toAlphaNumeric('-');
	retVal = retVal.replace(/([a-z])([A-Z])/g, '$1-$2');
	retVal = retVal.replace(/-+/g, '-');
	return retVal.toLowerCase();
};

String.prototype.ellipsis = String.prototype.ellipsis || function(truncateLength) {
	return this.length > truncateLength
		? this.substring(0, truncateLength) + '...' : this;
};

String.prototype.removeFromEnd = function(charsToRemove) {
	if (!this) return this;

	var endAt = this.length - charsToRemove;
	return this.slice(0, endAt);
};

// used in single metric widget
Math.log10 = Math.log10 || function (x) {
	return Math.log(x) / Math.LN10;
};

Number.prototype.pad = function (size) {
	var s = String(this);
	while (s.length < (size || 2)) {
		s = '0' + s;
	}
	return s;
};
Number.isInteger = Number.isInteger || function(value) {
	return typeof value === 'number'
		&& isFinite(value)
		&& Math.floor(value) === value;
};

//for java short type
Number.MAX_SHORT_INTEGER = Math.pow(2, 31) - 1;

Math.trunc = Math.trunc || function(x) {
	return x < 0 ? Math.ceil(x) : Math.floor(x);
};

/*
This is a workaround to angularjs mechanism, which doesn't expect ES6 syntax in function declaration
Such issue occurs after minification of services/components, which extends some base class, e.g. resulting js looks like

	class HierarchyDependencyTypesProvider extends __webpack_require__("./src/js/asset-management/dependencies/abstract-dependency-types-provider.ts").AbstractDependencyTypesProvider {
		constructor(locale, metricConverter, hierarchyDependenciesApiService) {

*/
let originalFnToString = Function.prototype.toString;
Function.prototype.toString = function() {
	var str = originalFnToString.apply(this, arguments);
	return str.replace(/extends __webpack_require__\(".*?"\)\./, 'extends ');
}


window.boolToString = function(value) {
	return value && value.toString() || 'false';
};

window.isTrue = function (value) {
	return value === true || value === 'true';
};

window.isFalse = function (value) {
	return value === false || value === 'false' || !value;
};

window.isEmpty = function (value) {
	return typeof value === 'undefined' || value === null || value === '' ||
		(value.constructor === Array && value.length === 0);
};

if (window.$) {
	$.fn.isInViewport = function () {
		var elementTop = $(this).offset().top;
		var elementBottom = elementTop + $(this).outerHeight();

		var viewportTop = $(window).scrollTop();
		var viewportBottom = viewportTop + $(window).height();

		return elementBottom > viewportTop && elementTop < viewportBottom;
	};

	['viewBox'].forEach(function (k) {
		$.attrHooks[k.toLowerCase()] = {
			set: function (el, value) {
				el.setAttribute(k, value);
				return true; // return true if it could handle it.
			},
			get: function (el) {
				return el.getAttribute(k);
			}
		};
	});
}
